import { css, unsafeCSS } from 'lit-element';
import {
  g55, g300, gm300, gm400, n50, white,
} from '@aab/sc-styles-colors';

const aabDatepickerStyles = css`
    :host {
      display: block;
      font-family: Roboto;
      padding-top: 16px;
      position: relative;
      margin-left: 8px;
      margin-right: 8px;
      width: 308px
    }

    .from-input-container, .to-input-container, .from-input-inputmessage-container, .to-input-inputmessage-container {
      width: 148px;
    }

    label {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: ${unsafeCSS(gm400)};
    }

    .calendar-show {
      z-index: 9999;
    }

     .sy_datetime_calender:hover {
       cursor: pointer;
     }

     .disabled-icon{
       cursor: not-allowed !important;
     }

    #datepicker-calendar {
        font-family: Roboto;
        width: 308px;
        background: ${unsafeCSS(white)};
      }

      div.th {
        line-height: 20px;
        font-weight: 500;
        color: ${unsafeCSS(gm300)};
        font-size: 14px;
        width: 42px;
      }

      div.tr {
        height: 40px;
      }

      div.td {
        width: 40px;
      }

      .month-block {
        height: 50px;
        width: 92px;
      }

      .month-block:hover {
        background: ${unsafeCSS(g55)};
        cursor: pointer;
      }

      .monthName {
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        color: ${unsafeCSS(g300)};
        height: 32px;
      }

      .monthName>div>div {
        height: 30px;
      }

      .appear {
        animation: fadeIn ease 250ms;
      }

      @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
      }

      .currentMonth, .currentYear {
        font-weight: 500;
        background-color: ${unsafeCSS(n50)};
      }

      .selectedMonth, .selectedYear {
        font-weight: 500;
        background: ${unsafeCSS(g300)} !important;
        color: ${unsafeCSS(white)};
      }

      .flex {
        flex: 1 1 1e-09px;
      }
      .sy_arrow_chevron_left, .sy_arrow_chevron_right,
      #day-view-header, #month-view-header, #year-view-header {
        cursor: pointer;
      }
`;

export default aabDatepickerStyles;
